import { gql } from '@apollo/client'

const GET_STATUS = gql`
query getStatus($page: Int!) {
  Status(page: $page) {
    nodes {
      color
      key
      percent
      text
      total
    }
    total
  }
}
`
const GET_ALL_STATUS = gql`
query getStatus {
  Status {
    nodes {
      color
      key
      percent
      text
      total
    }
    total
  }
}
`
const GET_ALL_USERS = gql`
query getusers {
  Users {
    total
    nodes {
      email
      name
      role {
        name
        id
      }
    }
  }
}
`
const GET_INCOMING = gql`
query getIncoming{
  Dashboard {
    incoming {
      name
      value
    }
  }
}
`
const GET_DEVICE = gql`
query getDevice{
  Dashboard {
    device {
      name
      value
    }
  }
}
`
const GET_SOURCE = gql`
query getSource{
  Dashboard {
    source {
      name
      value
    }
  }
}
`
const GET_LOCATIONS = gql`
query getLocations ($count: Int!){
  Leads(count: $count) {
    nodes {
      location_lon
      location_lat
      region
      country
    }
  }
}
`
const LOG_IN_QUERY = gql`
query SignIn($email:String!,$password:String!){
  login(email: $email, password: $password) {
    authToken
    refreshToken
    authExpiration
  }
}
`
const GET_LEADS = gql`
query getLeads($page:Int!,$count:Int!){
  Leads(page: $page,count: $count) {

    total
    nodes {
      id
      campaign
      name
      user {
        create_date
        name
        userid
      }
      status {
        color
        text
        key
      }
    }
  }
}
`
const GET_LEAD = gql`
query getLeads($value:Int!){
  Leads( where: {id: {compare: EQUAL, value: $value}}) {

    total
    nodes {
      id
      name
      country
      email
      phone
      city
      device
      region
      date
      utm
      campaign
      user {
        name
      }
      status {
        color
        key
        text
      }
    }
  }
}
`

const GET_STATUS_FLOW = gql`
query getStatusFlow ($lead_id: Int!){
  StatusFlow(lead_id:$lead_id) {
    nodes {
      status {
        color
        key
        text
      }
    }
  }
}
`
const GET_ACTIVITIES = gql`
query getActivities ($lead_id: Int!){
  Activities(lead_id: $lead_id) {
    nodes {
      date
      text
    }
  }
}
`
const GET_REMARKS = gql`
query getRemarks ($lead_id: Int!){
  Remarks(lead_id: $lead_id) {
    nodes {
      text
      date
      user {
        name
      }
      status {
        color
        key
        text
      }
    }
  }
}
`
const GET_REPORTS = gql`
query getRemarks ($path: String!){
  Report(path: $path) {
    total
    nodes {
      name
      value
      color
      percent
    }
  }
}
`



export {
  GET_STATUS,
  GET_INCOMING,
  GET_DEVICE,
  GET_SOURCE,
  GET_LOCATIONS,
  LOG_IN_QUERY,
  GET_LEADS,
  GET_ALL_STATUS,
  GET_LEAD,
  GET_STATUS_FLOW,
  GET_ACTIVITIES,
  GET_REMARKS,
  GET_ALL_USERS,
  GET_REPORTS
}
